import { Tabs, Space, Modal, Form, Input, Button, Select, Card, Table, Image, Row, Col, Tooltip, message } from "antd";
import { SearchOutlined, ReloadOutlined,ExclamationCircleFilled,ExclamationCircleOutlined } from "@ant-design/icons";
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import service from "../../../@services";
import { useEffect, useState } from "react";
import QueryString from "qs";
import { useLocation } from "react-router-dom";
import AuthComponent from "../../../components/AuthComponent";
const { TabPane } = Tabs;
export default function PriceAudit(props) {
  const { search } = useLocation();
  const [form] = Form.useForm();
  const [selectedRowKeys, onSelectChange] = useState([])
  const [id, setRejectItemId] = useState()
  const [storeId,onSelectStore] = useState("")
  const [tabActiveKey, setTabActiveKey] = useState("0")
  const [loading, setLoading] = useState(false)
  const [reason, setReason] = useState()
  const [reasonModalVisible, setReasonVisible] = useState(false)
  const [tableData, setTableData] = useState([])
  const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
  const [columns, setColumns] = useState([])
  const columns1 = [
    { title: '序号', dataIndex: '', key: 'index', render: (text,record,index)=> index+1 },
    { title: '申请单号', dataIndex: 'no', key: 'no' },
    { title: '商品信息', dataIndex: 'name', key: 'name', render: (text,record)=> (
      <span style={{fontSize: '12px'}}>
        <Row>
          <Col style={{color: '#3e9eff'}}>{record.name}</Col>
        </Row>
        <Row>
          <Col>商品编码：{record.outProductNo}</Col>
        </Row>
        <Row>
          <Col>商品条码：{record.barcode}</Col>
        </Row>
      </span>
    )},
    { title: '商品类别', dataIndex: 'categoryName', key: 'categoryName' },
    { title: '规格', dataIndex: 'specification', key: 'specification' },
    { title: '单位', dataIndex: 'packageUnitName', key: 'packageUnitName' },
    { title: ()=>{
        return (<Tooltip title="移动平均价">成本价 <ExclamationCircleFilled /></Tooltip>)
      }, dataIndex: 'costPrice', key: 'costPrice', render: (text, record) =>text?<span>{text}</span>:<span>-</span>
    },
    { title: '当前销售价', dataIndex: 'currentPrice', key: 'currentPrice', render: (text, record) =>text?<span style={{color: 'red'}}>{text}</span>:<span>-</span> },
    { title: '新销售价', dataIndex: 'newPrice', key: 'newPrice', render: (text, record) =><span style={{color: 'red'}}>{text}</span> },
    { title: '申请人', dataIndex: 'operName', key: 'operName' },
    { title: '申请时间', dataIndex: 'operTime', key: 'operTime' },

  ];
  const columns2 = [
    {
      title: '操作',
      width: '150px',
      dataIndex: '',
      key: 'x',
      render: (text,record,index) => (
        <Space style={{flexWrap: 'wrap'}}>
          <AuthComponent authKey="/product/price-adjust/pass"><Button onClick={()=>passPriceUpdate(record.id)} type="link">通过</Button></AuthComponent>
          <AuthComponent authKey="/product/price-adjust/reject"><Button onClick={()=>rejectPriceUpdate(record.id)} type="link">驳回</Button></AuthComponent>
        </Space>
      ),
    },
  ]
  const columns3 = [
    { title: '审核人', dataIndex: 'auditorName', key: 'auditorName' },
    { title: '审核时间', dataIndex: 'auditorTime', key: 'auditorTime' },
  ]
  const columns4 = [
    { title: '审核人', dataIndex: 'auditorName', key: 'auditorName' },
    { title: '审核时间', dataIndex: 'auditorTime', key: 'auditorTime' },
    { title: '驳回原因', width: '150px', dataIndex: 'reason', key: 'reason', render: (text, record) => (<span style={{wordBreak: 'break-word'}}>{text}</span>)},
  ]
  useEffect(() => {
    let query = QueryString.parse(decodeURIComponent(search.replace("?", "")));
    form.setFieldsValue({
      no: query.auditNo
    })
    setTabActiveKey(query.status||"0")
  }, [search]);
  useEffect(() => {
    tabActiveKey=="0"&&setColumns([...columns1,...columns2])
    tabActiveKey=="1"&&setColumns([...columns1,...columns3])
    tabActiveKey=="2"&&setColumns([...columns1,...columns4])
    onSearch()
  }, [tabActiveKey,storeId]);
  const setDefaultStore = (res)=>{
    form.setFieldsValue({
      storeId: res.id
    })
    onSelectStore(res.id)
  }
  const onSearch = () => {
    if(!storeId){
      //message.warning('请选择门店');
      return
    }
    const params = Object.assign({},form.getFieldsValue(),{ pageIndex: 1, pageSize: 10})
    fetchData(params)
  }
  const onReset = () => {
    form.resetFields();
  };
  const handleTableChange = (pagination) => {
    setPagination(pagination)
    const params = Object.assign({},form.getFieldsValue(),{ pageIndex: pagination.current, pageSize: pagination.pageSize})
    fetchData(params)
  }
  const fetchData = async (params) => {
    params.status = parseInt(tabActiveKey)
    setLoading(true)
    const data = await service.price.getPriceAuditList(params)
    setLoading(false)
    if(data){
      setTableData(data.result)
      setPagination({
        showSizeChanger: true,
        showQuickJumper: true,
        current: data.pageIndex,
        pageSize: data.pageSize,
        total: data.recordCount
      })
    }
  }
  const passPriceUpdate = async (id) => {
    if(!id&&selectedRowKeys.length===0){
      message.warning('请选择商品');
      return
    }
    const ids = id?[id]:selectedRowKeys
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: `确认审核通过当前价格吗？审核通过新销售价立即生效`,
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        id
        ? await service.price.passPriceAudit({ids})
        : await service.price.batchPassPriceAudit({ids})
        message.success('审核通过');
        onSearch()
      }
    });
  };
  const rejectPriceUpdate = async (id) => {
    if(!id&&selectedRowKeys.length===0){
      return message.warning('请选择商品');
    }
    setRejectItemId(id)
    setReasonVisible(true)
    setReason()
  };
  const onRejectPrice = async ()=>{
    if(!reason){
      return message.warning('请填写驳回原因');
    }
    const ids = id?[id]:selectedRowKeys
    id
    ? await service.price.rejectPriceAudit({ids,reason})
    : await service.price.batchRejectPriceAudit({ids,reason})
    setReasonVisible(false)
    message.success('审核驳回');
    onSearch()
  }
  const onTabChange = (key) => {
    setTabActiveKey(key)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <Form
          form={form}
          layout="inline"
        >
          <Form.Item name="storeId" label="所属门店">
            <ShopSelect style={{ width: 200 }} keyVal='id'
            OnOptionsLoad={setDefaultStore} onChange={onSelectStore} />
          </Form.Item>
          <Form.Item name="productInfo" label="商品信息">
            <Input style={{ width: 200 }} placeholder="商品名称/条码/商品编码" />
          </Form.Item>
          <Form.Item name="no" label="申请单号">
            <Input style={{ width: 200 }} placeholder="请输入申请单号" />
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/price-adjust/page">
              <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
            </AuthComponent>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/price-adjust/page">
              <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </AuthComponent>
          </Form.Item>
        </Form>
      </Card>
      <Tabs
        style={{marginTop: '-5px', marginBottom: '-23px'}}
        activeKey={tabActiveKey}
        onChange={onTabChange}
      >
        <TabPane tab="待审核" key={0}></TabPane>
        <TabPane tab="已通过" key={1}></TabPane>
        <TabPane tab="已驳回" key={2}></TabPane>
      </Tabs>
      <Space style={{ display: "flex", background: "#ffffff", padding: "15px", marginBottom: "-10px" }}>
        {
        tabActiveKey === "0" &&
        <AuthComponent authKey="/product/price-adjust/batch/pass"><Button type="primary" onClick={()=>passPriceUpdate()}>批量通过</Button>
        </AuthComponent>
        }
        {
        tabActiveKey === "0" &&
        <AuthComponent authKey="/product/price-adjust/batch/reject">
        <Button type="primary" onClick={()=>rejectPriceUpdate()}>批量驳回</Button>
        </AuthComponent>
        }
      </Space>
      <Table
        rowKey={record=>record.id}
        dataSource={tableData}
        rowSelection={rowSelection}
        pagination={pagination}
        loading={loading}
        columns={columns}
        onChange={handleTableChange}
      />
      <Modal
        visible={reasonModalVisible}
        width="40%"
        title="提示"
        onCancel={()=>{setReasonVisible(false)}}
        onOk={onRejectPrice}
        cancelText="取消"
        okText="确认"
      >
        <>
          <div>驳回原因:</div>
          <Input.TextArea value={reason} onChange={({target})=>{setReason(target.value)}} maxLength={100} showCount placeholder="（必填）请输入驳回原因" rows={2} />
        </>
      </Modal>
    </Space>
  );
}
